import { render, staticRenderFns } from "./Anexos.vue?vue&type=template&id=84df778c&scoped=true&"
import script from "./Anexos.vue?vue&type=script&lang=js&"
export * from "./Anexos.vue?vue&type=script&lang=js&"
import style0 from "./Anexos.vue?vue&type=style&index=0&id=84df778c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84df778c",
  null
  
)

export default component.exports